<div class="account-setup">
  <div>
    <div class="col-12">
      <div class="heading" role="heading" aria-level="1">
        <adp-label labelKey="Signup_Success_Heading_Text"></adp-label> <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
      </div>
    </div>
  </div>
  <div class="success-container container">
    <div class="row">
      <div class="col-12">
        <p class="text-center success-label">
          <adp-label labelKey="Signup_Success_Body_Text"></adp-label>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="text-center thanks-text">
          <adp-label labelKey="Signup_Success_ThankYou_Text"></adp-label>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button mat-flat-button color="accent" (click)="navigateToLogin()">
          <adp-label labelKey="Signup_Success_DoneButton_Text"></adp-label>
        </button>
      </div>
    </div>
  </div>
</div>